
<template>
    <div>
        <form @submit.prevent="submit">
            <div class="form-body d-flex flex-column p-3 p-md-4">
                <div class="form-group">
                    <input class="form-control p-3" type="text" placeholder="Full Name *" name="name" id="name"
                        v-model="form.name">
                    <div v-if="errors && errors.name" class="text-danger">{{ errors.name }}</div>
                </div>
                <div class="form-group">
                    <input class="form-control p-3" type="email" placeholder="Your email *" name="email" id="email"
                        v-model="form.email">
                    <div v-if="errors && errors.email" class="text-danger">{{ errors.email }}</div>
                </div>
                <div class="form-group">
                    <input class="form-control p-3" type="text" placeholder="Company website" name="website" id="website"
                        v-model="form.website">
                    <div v-if="errors && errors.website" class="text-danger">{{ errors.website }}</div>
                </div>
                <div class="form-group">
                    <div id="dropdown" class="dropdown">
                        <button type="button" id="dropdownButton" class="dropdownButton p-3" data-flip="false"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span v-if="form.industry.name === null" style="color: #989898; line-height: 1;">
                                What industry do you work in? *
                            </span>
                            <span v-else style="line-height: 1;">
                                {{ form.industry.name }}
                            </span>
                        </button>
                        <div class="dropdown-menu" aria-labelledby="dropdownButton">
                            <div v-for="industry in industries" :key="industry.id" @click="form.industry = industry"
                                :class="{ 'active': industry.id === form.industry.id }" class="dropdown-item">
                                {{ industry.name }}
                            </div>
                        </div>
                    </div>
                    <div v-if="errors && errors.industry" class="text-danger">{{ errors.industry }}</div>
                </div>
                <div class="form-group">
                    <textarea id="message" name="message" rows="5" class="form-control p-3" v-model="form.message"
                        placeholder="Please describe the white label solution you’re looking to build. Note: Your use case can’t directly compete with Infinity.*"></textarea>
                    <div v-if="errors && errors.message" class="text-danger">{{ errors.message }}</div>
                </div>
                <span class="text-center">If it seems like we’re a good fit, we’ll contact you to talk about the next steps and arrange a free consultation.</span>
                <button class="send-btn cta-btn-v2 mb-0 mx-auto" :disabled="busy">
                    Apply Now
                    <div v-if="busy" class="lds-ring ml-2">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <span v-else class="ic-arrow ml-2" />
                </button>
                <div v-if="tooMany" class="text-danger text-center mt-4">{{ tooMany }}</div>
            </div>
        </form>
        <div v-if="formSubmitted">
            <div class="checkout-modal-wrapper"
                style="overflow: unset; max-width: 95%; width: 800px;">
                <div class="d-block dark-bg text-left p-5 text-center position-relative thank-you-modal">
                    <img @click.prevent="formSubmitted = false" src="/img/home-v2/fomo-modal-exit.svg" class="exit-modal cursor-pointer position-absolute"  alt="exit button icon">
                    <h3>Thank you for applying for Infinity Echo!</h3>
                    <p class="mt-3 mb-0">
                        We’re thrilled that you’re interested in customizing and branding your own software with Infinity Echo. Our team is currently reviewing your application and will be in touch with you shortly to discuss the next steps.
                    </p>
                    <!-- <a href="" ref="activatePlanBtn" class="cta-btn-v2" target="_blank">CTA</a> -->
                </div>
            </div>
            <div id="popup-overlay" style="display: block;" @click.prevent="formSubmitted = false">
            </div>
        </div>
    </div>
</template>
<script>
import VueCalendly from 'vue-calendly';

Vue.use(VueCalendly);
import axios from 'axios';
export default {
    data() {
        return {
            form: {
                name: null,
                email: null,
                website: null,
                industry: {
                    id: null,
                    name: null
                },
                message: null,
            },
            errors: {},
            industries: [
                {
                    id: '64efcdad-b50b-4479-ad0e-2f762f642616',
                    name: 'Marketing',
                },
                {
                    id: 'a0effff1-fe8a-4fbc-aa74-e0bc6603fa34',
                    name: 'Sales',
                },
                {
                    id: '6da24221-5b4d-4a92-a82a-ee1b70cd5fab',
                    name: 'IT',
                },
                {
                    id: '06e82b9e-e712-4200-a969-6df9300f8f6c',
                    name: 'Finance',
                },
                {
                    id: '82479963-465e-477b-9347-635c8c373fa8',
                    name: 'Education',
                },
                {
                    id: '342f8fe1-4469-4111-8f7b-63cad8303630',
                    name: 'Legal',
                },
                {
                    id: '128c31ac-8766-4b9c-aa1a-482327f3a682',
                    name: 'HR',
                },
                {
                    id: '2685689e-1663-4bf1-b714-721ad2786b7f',
                    name: 'Retail',
                },
                {
                    id: '6f9b88a2-61e7-4240-84bd-9a9895ee953f',
                    name: 'Healthcare',
                },
                {
                    id: '69c0956c-156d-469c-aa4d-933643e1d7cc',
                    name: 'Gaming',
                },
                {
                    id: '2cd03343-31f0-484b-9633-eee1e19964b1',
                    name: 'Government',
                },
                {
                    id: '0ec76568-638e-44a0-8065-08ace3cef1e2',
                    name: 'Art & Design',
                },
                {
                    id: 'd4e1c506-6886-4b73-8ea9-239fd4f090fe',
                    name: 'Tourism',
                },
                {
                    id: '9b9fb4a5-bbdb-4814-9e6f-ac46c14c37e9',
                    name: 'Real Estate',
                },
                {
                    id: '55d26c89-fdc4-4a07-a334-b3a09cdde748',
                    name: 'E-Commerce',
                },
                {
                    id: '510ce2c5-8e44-4cb8-9573-53e746abe3fc',
                    name: 'Consumer Goods',
                },
                {
                    id: '5f2019de-568b-454f-a381-1caed76ec6d5',
                    name: 'Non-Profit',
                },
                {
                    id: '33afe148-95be-4d28-ba3c-ed6c1e21e12e',
                    name: 'Manufacturing',
                },
                {
                    id: '07d2d208-cf65-41cc-b50a-963a3092dd0c',
                    name: 'Other',
                }
            ],
            formSubmitted: false,
            tooMany: null
        };
    },
    methods: {
        resetForm() {
            this.form = {
                name: null,
                email: null,
                industry: { name: null, id: null },
                message: null,
                website: null
            };
        },
        formValidate() {
            this.errors = {};
            this.tooMany = null;
            if (this.form.name == null) {
                this.errors.name = 'Name is required';
            }
            if (this.form.email == null) {
                this.errors.email = 'Email is required';
            }

            if (this.form.industry.id == null) {
                this.errors.industry = 'Industry is required';
            }

            if (this.form.message == null) {
                this.errors.message = 'Message is required';
            }
            if (this.form.website !== null && !this.form.website.includes('http://') && !this.form.website.includes('https://')) {
                this.errors.website = 'Please enter a website address with the "http://" or "https://" protocol. For example, use "https://www.example.com" instead of "www.example.com".';
            }

        },
        submit() {
            this.formValidate();
            this.busy = true;
            this.formValidate();
            if (Object.keys(this.errors).length === 0) {
                axios.post('/echo-contact-submit', this.form).then(() => {
                    this.busy = false;
                    // Reset form here after successful submission
                    this.resetForm();
                    this.formSubmitted = true;
                    dataLayer.push({
                        event: 'echoApplyForm',
                    });
                }).catch(error => {
                    if (error.response.status === 429) {
                        this.tooMany = error.response.data.message;
                    }
                    if (error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                    }
                });
            } else {
                this.busy = false;
            }
        },
    },
};
</script>

<style scoped lang="less">
.lds-ring {
    display: inline-block;
    position: relative;
    width: 20px;
    height: 20px;
}

.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    border: 2px solid #fff;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #fff transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
}

@keyframes lds-ring {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

h3 {
    font-size: 30px !important;
    font-family: 'Avenir Next Medium';
}

.dropdown {
    .dropdownButton {
        // appearance: none;
        width: 100%;
        min-height: 40px;
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.06);
        color: #fff;
        background: #0F1728;
        padding: 10px;
        font-size: 18px;
        background-image: url('/img/pricing/dropdown-arrow-down-white.svg');
        background-repeat: no-repeat;
        background-size: 15px 9px;
        background-position: 98% 50%;
        text-align: left;
        display: flex;
        align-items: center;

        &:focus,
        &:active {
            border: 1px solid #BFB6FF;
            outline: none;
        }
    }

    .dropdown-menu {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.25);
        border-radius: 6px;
        padding: 7px;
        height: 250px;
        max-height: 90vh;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            border-radius: 10px;
            width: 8px;
            background-color: #F5F5F5;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: #62647b36;
        }

        .dropdown-item {
            cursor: pointer;
            border-radius: 6px;
            font-size: 18px;

            &:hover {
                background-color: #F6F4FF;
            }
        }

        .dropdown-item.active {
            background-color: transparent;
            color: #5946CF;
            background-image: url('/img/pricing/ic-check.svg');
            background-repeat: no-repeat;
            background-size: 15px 9px;
            background-position: 100% 50%;
            text-align: left;
        }
    }
}

.form-body {
    gap: 24px;
    height: fit-content;
    border-radius: 8px;
    border: 1px solid rgba(111, 207, 235, 0.1);

    background: linear-gradient(150deg, rgba(41, 51, 80, 0.50) 2.16%, rgba(37, 45, 67, 0.50) 95.91%);

    backdrop-filter: blur(8px);
}

.form-body h2 {
    font-size: 35px;
    line-height: 48px;
}

.form-body p {
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
}

.form-control::placeholder {
    color: #989898;
}

input[type="text"],
input[type="email"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;

    &:focus,
    &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}

textarea {
    height: 120px;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 10px;

    &:focus,
    &:active {
        border: 1px solid #BFB6FF;
        outline: none;
    }
}

.form-control {
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    color: #fff;
    background: #0F1728;
    font-size: 18px;
    line-height: 19px;
    height: auto;
    &:focus {
        box-shadow: unset;
    }
}

.form-group {
    margin-bottom: 0;
}
.form-group:focus {
    outline: none;
}

.send-btn {
    cursor: pointer;
    border: none;
}

.send-btn:active {
    outline: none;
}

.send-btn:focus {
    outline: none;
}

.message {
    display: flex;
    justify-content: center;
    align-items: center;
    // margin-top: 40px
}
.exit-modal {
    top: 10px;
    right: 10px;
}
.thank-you-modal {
    border-radius: 8px;
}
</style>






// WEBPACK FOOTER //
// resources/js/frontend/components/EchoSubscribe.vue